import { render } from "./Beam.vue?vue&type=template&id=fe9d5774&scoped=true"
import script from "./Beam.vue?vue&type=script&lang=js"
export * from "./Beam.vue?vue&type=script&lang=js"

import "./Beam.vue?vue&type=style&index=0&id=fe9d5774&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-fe9d5774"

export default script